// extracted by mini-css-extract-plugin
export default {"wrap":"wrap§FjVMzf3jwGBxLopC9Qa4","tag":"tag§pcUhfKeY8LsmOLLIROkW","emphasizeName":"emphasizeName§Ts6HOEU11n9vkHIpAxoK","phoneTooltip":"phoneTooltip§_VgBapBmv6sYawzkbILt"};